import { apiService } from './api';

export interface MenuEngineeringItem {
  menuItemId: number;
  itemName: string;
  categoryName?: string;
  totalQtySold: number;
  totalRevenue: number;
  foodCostPerUnit: number;
  totalFoodCost: number;
  contributionMargin: number;
  foodCostPercent: number;
  popularityIndex: number;
  classification: 'Star' | 'Plowhorse' | 'Puzzle' | 'Dog';
  costSource?: string;
}

export interface MenuEngineeringReport {
  startDate?: string;
  endDate?: string;
  totalItems: number;
  stars: number;
  plowhorses: number;
  puzzles: number;
  dogs: number;
  averageFoodCostPercent: number;
  items: MenuEngineeringItem[];
}

const menuEngineeringService = {
  getReport: (startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate)   params.append('endDate', endDate);
    return apiService.get<{ data: MenuEngineeringReport }>(
      `/reports/restaurant/menu-engineering${params.toString() ? '?' + params.toString() : ''}`
    );
  },
};

export default menuEngineeringService;
